jQuery(document).ready(function onPremiersReady($) {
    "use strict";

    if($('.premiers-page').length === 0) {
        return;
    }

    var $countdown = $('.countdown');
    for(var i = 0, l = $countdown.length; i < l; ++i) {
        countdown($($countdown[i]));
    }

    function countdown($element) {
        var release = new Date(parseInt($element.data('end'), 10) * 1000);
        var $days = $element.find('.countdown__item--days time');
        var $hours = $element.find('.countdown__item--hours time');
        var $minutes = $element.find('.countdown__item--minutes time');
        var $seconds = $element.find('.countdown__item--seconds time');

        setInterval(tick, 1000);

        function tick() {
            var now = new Date();

            // get total seconds between the times
            var delta = Math.abs(release - now) / 1000;

            // calculate (and subtract) whole days
            var days = Math.floor(delta / 86400);
            delta -= days * 86400;

            // calculate (and subtract) whole hours
            var hours = Math.floor(delta / 3600) % 24;
            delta -= hours * 3600;

            // calculate (and subtract) whole minutes
            var minutes = Math.floor(delta / 60) % 60;
            delta -= minutes * 60;

            // what's left is seconds
            var seconds = delta % 60;  // in theory the modulus is not required

            $days.text(Math.round(days));
            $hours.text(Math.round(hours));
            $minutes.text(Math.round(minutes));
            $seconds.text(Math.round(seconds));
        }
    }

});
